/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleDto } from '../../models/enrollment-schedule-dto';

export interface EnrollmentScheduleControllerFindLastScheduleV1$Params {
  ticketId: string;
}

export function enrollmentScheduleControllerFindLastScheduleV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindLastScheduleV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindLastScheduleV1.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentScheduleDto>;
    })
  );
}

enrollmentScheduleControllerFindLastScheduleV1.PATH = '/api/v1/enrollment-schedule/last';
